// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a5f44f41","707":"7bbe0ec0","968":"d0e5cdba"}[chunkId] + ".chunk.js";
};